function kmKonfiguratorInit(root) {
  var sid = root.getAttribute('data-section-id');
  var R = JSON.parse(document.getElementById('km-rules-' + sid).textContent);
  var IMG = JSON.parse(document.getElementById('km-images-' + sid).textContent);
  var CTX = JSON.parse(document.getElementById('km-ctx-' + sid).textContent);
  // Länderpreis-Faktor: Netto EU-weit gleich, Landessteuer drauf (R.steuer).
  // Länder ohne Eintrag (z. B. CH) → 1 = DE-Preis. Muss der Function-Rechnung entsprechen.
  var TAXF = (function () {
    var st = R.steuer;
    if (!st || !st.saetze || !CTX.country) return 1;
    var satz = st.saetze[CTX.country];
    if (satz === undefined || satz === null) return 1;
    return (100 + Number(satz)) / (100 + Number(st.basissatz || 19));
  })();
  // Steuersatz des Besucherlands fuer den Netto-Ausweis. Laender ohne Eintrag (z. B. CH)
  // bekommen keine Nettozeile - dort faellt keine deutsche Umsatzsteuer an, ein Ausweis
  // waere falsch. Gleiche Logik wie in km-nettopreis.liquid.
  var TAXSATZ = (function () {
    var st = R.steuer;
    if (!st || !st.saetze || !CTX.country) return null;
    var satz = st.saetze[CTX.country];
    if (satz === undefined || satz === null) return null;
    return Number(satz);
  })();

  var form = document.getElementById('km-form-' + sid);
  var els = {
    total: document.getElementById('km-total-' + sid),
    netto: document.getElementById('km-netto-' + sid),
    liste: document.getElementById('km-liste-' + sid),
    detail: document.getElementById('km-detail-' + sid),
    flag: document.getElementById('km-flag-' + sid),
    add: document.getElementById('km-add-' + sid),
    quote: document.getElementById('km-quote-' + sid),
    share: document.getElementById('km-share-' + sid),
    msg: document.getElementById('km-msg-' + sid),
    handlauf: document.getElementById('km-handlauf-' + sid)
  };

  // --- Anbindung an die Standard-Produktgalerie (Focal) ---
  // Die Maßskizze ist ein echtes Produktmedium (alt "km:skizze"); ihr Bild wird
  // bei jeder Eingabe live durch eine SVG-Data-URL ersetzt (Slider, Thumbnail, Zoom).
  var MEDIA = IMG.media || {};
  var MEDIA_URL = IMG.media_url || {};

  // Der Bild-Zoom des Themes (PhotoSwipe) baut seine Bildliste neu aus
  // /products/<handle>.js auf und liest das <img> im DOM nicht. Die live gezeichnete
  // Skizze sieht er deshalb nie - die Lupe zeigte das urspruenglich hochgeladene Bild
  // mit Standardmass. Wir merken uns die aktuelle Zeichnung je Medien-ID und haengen
  // uns einmalig hinter _buildItems, um die Quelle des Skizzen-Mediums zu ersetzen.
  window.__kmSkizzen = window.__kmSkizzen || {};
  function zoomVerdrahten() {
    if (!window.customElements || !customElements.whenDefined) return;
    customElements.whenDefined('product-image-zoom').then(function () {
      var K = customElements.get('product-image-zoom');
      if (!K || !K.prototype || K.prototype.__kmZoomPatch) return;
      var original = K.prototype._buildItems;
      if (typeof original !== 'function') return;
      K.prototype._buildItems = function () {
        return Promise.resolve(original.apply(this, arguments)).then(function (items) {
          (items || []).forEach(function (eintrag) {
            var id = eintrag && eintrag.originalMedia ? String(eintrag.originalMedia.id) : '';
            var url = window.__kmSkizzen[id];
            if (!url) return;
            eintrag.src = url;
            eintrag.msrc = url;
            eintrag.w = 1600;
            eintrag.h = 1280;
          });
          return items;
        });
      };
      K.prototype.__kmZoomPatch = true;
    }).catch(function () {});
  }
  zoomVerdrahten();
  var SK_ID = MEDIA['skizze'] || null;

  var zuletztMedium = null;
  function selectMedia(id) {
    zuletztMedium = String(id);
    var thumb = document.querySelector('.product__thumbnail-item[data-media-id="' + id + '"]');
    if (thumb) { thumb.click(); return; }
    var item = document.querySelector('.product__media-item[data-media-id="' + id + '"]');
    var car = document.querySelector('.product__media-list');
    if (item && car && window.Flickity) {
      var f = window.Flickity.data(car);
      if (f) f.selectCell(item);
    }
  }

  // Ein SVG, das als data:-URL in ein <img> geladen wird, laeuft im gesicherten
  // Bildmodus: externe Ressourcen werden nicht geladen (MDN, "SVG as an Image").
  // Das per <image href="https://..."> eingebettete Detailbild der Befestigung blieb
  // deshalb leer - sichtbar als leerer Kasten oben rechts in der Skizze. Loesung:
  // Icon einmalig ueber ein Canvas auf 240 px verkleinern, als data:-URL merken und
  // in das SVG einbetten. Solange nichts im Cache liegt, wird der Kasten weggelassen,
  // damit nie ein leerer Rahmen erscheint.
  var ICON_CACHE = {};
  function iconDaten(url) {
    if (!url) return null;
    if (url in ICON_CACHE) return ICON_CACHE[url];
    ICON_CACHE[url] = null;
    var bild = new Image();
    bild.onload = function () {
      try {
        var k = 240;
        var c = document.createElement('canvas');
        c.width = k; c.height = k;
        var ctx = c.getContext('2d');
        ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, k, k);
        var m = Math.min(k / bild.width, k / bild.height);
        var w = bild.width * m, h = bild.height * m;
        ctx.drawImage(bild, (k - w) / 2, (k - h) / 2, w, h);
        ICON_CACHE[url] = c.toDataURL('image/png');
        update();
      } catch (e) {}
    };
    bild.src = url;
    return null;
  }

  var currentRenderKey = null;
  var galerieBereit = false; // erst nach dem Seitenaufbau in die Galerie greifen
  function showRender(key) {
    // Nur springen, wenn sich Material/Befestigung wirklich geändert haben –
    // Maßeingaben lassen die aktuelle Ansicht (z. B. die Skizze) stehen.
    if (key === currentRenderKey) return;
    var vorher = currentRenderKey;
    currentRenderKey = key;
    // Beim ersten Durchlauf nur merken: Ein Sprung waehrend des Seitenaufbaus
    // scrollt die Galerie durch alle 17 Medien und landet auf einem Bild, das
    // wegen loading="lazy" noch gar nicht da ist - der Kunde sieht einen grauen
    // Kasten. Das Hauptfoto bleibt stehen, bis der Kunde selbst etwas auswaehlt.
    if (!galerieBereit) return;
    var id = MEDIA[key];
    if (!id) return;
    // Nur die Schlosszahl hat sich geaendert (Hoehe ueber/unter 1500 mm): Schaut der Kunde
    // gerade die Masszeichnung an, bleibt sie stehen - das Bild wechselt nur, wenn das
    // Oeffnungsbild selbst angezeigt wird.
    if (vorher && /^oeffnung\|/.test(vorher) && /^oeffnung\|/.test(key) && zuletztMedium !== String(MEDIA[vorher])) return;
    selectMedia(id);
  }
  // Galerie-Schluessel der Auswahl: mit Oeffnungsfunktion das Prinzipbild zur Schlosszahl
  // ("oeffnung|1" bzw. "oeffnung|2" in custom.km_medien), sonst Befestigung und Material.
  function renderKey(s) {
    if (s.oe && s.oe.id !== 'ohne') {
      var n = schlossZahl(s) || 1;
      if (MEDIA['oeffnung|' + n]) return 'oeffnung|' + n;
    }
    return s.befestigung + '|' + s.material;
  }
  // Modelle ohne parametrische Skizze (Fenstergitter) fuehren je Befestigungsart eine
  // eigene Werkzeichnung als Produktmedium: Schluessel "zeichnung|<befestigung>" in
  // custom.km_medien. Wo eine Skizze gerechnet wird, bleibt es bei der einen Skizzen-ID.
  function zeichnungId(s) {
    var bf = s && s.befestigung;
    return (bf && MEDIA['zeichnung|' + bf]) || SK_ID || null;
  }
  function selectSkizze() {
    var id = zeichnungId(state());
    if (!id) return;
    selectMedia(id);
  }
  function skizzeTargets() {
    if (!SK_ID) return [];
    var found = [];
    document.querySelectorAll('.product__media-item[data-media-id="' + SK_ID + '"], .product__thumbnail-item[data-media-id="' + SK_ID + '"]').forEach(function (c) {
      c.querySelectorAll('img, source').forEach(function (n) { found.push(n); });
    });
    return found;
  }

  function fmt(n) { return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
  function byId(list, id) { for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i]; return list[0]; }
  // Wie byId, aber ohne den stillen Rueckfall auf die erste Option. Nur damit laesst sich
  // unterscheiden, ob der Kunde wirklich gewaehlt hat oder ob ihm die Vorauswahl
  // untergeschoben wurde - byId allein verwischt genau diesen Unterschied.
  function findeId(list, id) { for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i]; return null; }
  function clamp(v, min, max) { v = Number(v); if (isNaN(v)) v = min; return Math.min(max, Math.max(min, v)); }

  function esc(t) {
    return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function state() {
    var fd = new FormData(form);
    var s = {
      material: fd.get('material'),
      farbe: fd.get('farbe'),
      farbe_wunsch: (fd.get('farbe_wunsch') || '').trim(),
      breite: Number(fd.get('breite')),
      hoehe: Number(fd.get('hoehe')),
      befestigung: fd.get('befestigung'),
      handlauf: fd.get('handlauf'),
      oeffnung: fd.get('oeffnung'),
      menge: Number(fd.get('menge')) || 1,
      set: fd.get('set'),
      fertigungsstart: fd.get('fertigungsstart') || 'sofort',
      bemerkung: (fd.get('bemerkung') || '').trim()
    };
    s.m = byId(R.material.optionen, s.material);
    s.b = byId(R.befestigung.optionen, s.befestigung);
    s.s = byId(R.sets.optionen, s.set);
    // Pflichtauswahl fehlt (kein Radio gesetzt, unbekannter Wert): Anzeige faellt auf die
    // erste Option zurueck, damit Preis und Galerie nicht abstuerzen - der Warenkorb bleibt
    // aber gesperrt, bis der Kunde selbst gewaehlt hat. Ohne das landet eine Konfiguration
    // im Auftrag, die niemand ausgesucht hat (Bestellung #1575, 09.09.2026).
    s.fehlt = [];
    if (!findeId(R.material.optionen, s.material)) s.fehlt.push({ schritt: 'material', label: R.material.label || 'Material' });
    if (!findeId(R.befestigung.optionen, s.befestigung)) s.fehlt.push({ schritt: 'befestigung', label: R.befestigung.label || 'Befestigung' });
    if (!findeId(R.sets.optionen, s.set)) s.fehlt.push({ schritt: 'sets', label: R.sets.label || 'Befestigungsmaterial' });
    if (R.oeffnung && !findeId(R.oeffnung.optionen, s.oeffnung)) s.fehlt.push({ schritt: 'oeffnung', label: R.oeffnung.label || 'Öffnung' });
    if (s.m && s.m.farbe && !s.farbe) s.fehlt.push({ schritt: 'material', label: (R.farbe && R.farbe.label) || 'Farbe' });
    // Zusatzoption mit Aufpreis - bei den Fenstergittern die Funktion zum Oeffnen mit Schloss.
    // Familien ohne diesen Block (Balkone) liefern hier schlicht null.
    s.oe = R.oeffnung ? (byId(R.oeffnung.optionen, s.oeffnung) || R.oeffnung.optionen[0]) : null;
    s.hl = null;
    if (s.m.handlauf && R.handlauf && R.handlauf.varianten[s.m.handlauf]) {
      var list = R.handlauf.varianten[s.m.handlauf];
      for (var i = 0; i < list.length; i++) if (list[i].label === s.handlauf) s.hl = list[i];
      if (!s.hl) s.hl = list[0];
    }
    return s;
  }

  // "Farbe nach Wahl" ist die Option ohne Farbwert. Nur dann wird der Farbton abgefragt.
  function istWunschfarbe(s) {
    if (!s.m.farbe || !s.farbe || !R.farbe || !R.farbe.optionen) return false;
    for (var i = 0; i < R.farbe.optionen.length; i++) {
      var o = R.farbe.optionen[i];
      if (o.label === s.farbe) return !o.hex;
    }
    return false;
  }
  // Der Farbtext, der in Preisliste, Warenkorb und Angebot steht.
  function farbText(s) {
    if (!s.m.farbe || !s.farbe) return '';
    return istWunschfarbe(s) && s.farbe_wunsch ? s.farbe_wunsch + ' (Wunschfarbe)' : s.farbe;
  }

  function validate(s) {
    var ok = true;
    // Bei fester Hoehe (Fensterstangen) gibt es kein Hoehenfeld und damit auch keine Fehlerzeile
    // dazu - der Zugriff muss deshalb defensiv sein, sonst bricht validate() ab und der
    // Warenkorb-Knopf reagiert nicht mehr.
    var eB = root.querySelector('[data-err="breite"]'), eH = root.querySelector('[data-err="hoehe"]');
    if (eB) eB.hidden = true;
    if (eH) eH.hidden = true;
    if (s.breite < R.breite.min || s.breite > R.breite.max || !s.breite) {
      if (eB) { eB.textContent = 'Bitte einen Wert zwischen ' + R.breite.min + ' und ' + R.breite.max + ' mm eingeben.'; eB.hidden = false; }
      ok = false;
    }
    if (s.hoehe < R.hoehe.min || s.hoehe > R.hoehe.max || !s.hoehe) {
      if (eH) { eH.textContent = 'Bitte einen Wert zwischen ' + R.hoehe.min + ' und ' + R.hoehe.max + ' mm eingeben.'; eH.hidden = false; }
      ok = false;
    }
    var eF = root.querySelector('[data-err="farbe"]');
    if (eF) {
      eF.hidden = true;
      if (istWunschfarbe(s) && !s.farbe_wunsch) {
        eF.textContent = 'Bitte nennen Sie den gewünschten Farbton, z. B. RAL 6005.'; eF.hidden = false; ok = false;
      }
    }
    // Kein Schritt darf offen bleiben: was hier fehlt, fehlte sonst auch im Auftrag.
    if (s.fehlt && s.fehlt.length) ok = false;
    return ok;
  }

  // Der Set-Preis kann von der Groesse abhaengen: bei den Fenstergittern setzen wir ab
  // 1500 mm Laibungshoehe sechs Befestigungspunkte statt vier, das Set wird entsprechend groesser.
  function punkteZahl(s) {
    var pk = R.sets && R.sets.punkte;
    if (!pk) return null;
    return s.hoehe >= Number(pk.ab_hoehe) ? Number(pk.punkte_ab) : Number(pk.punkte_unter);
  }
  function setPreis(s) {
    if (!s.s) return 0;
    var n = punkteZahl(s);
    if (n !== null && s.s.punkte) {
      var e = s.s.punkte[String(n)];
      return e ? Number(e.preis || 0) : 0;
    }
    return Number(s.s.preis || 0);
  }

  // Oeffnungsfunktion der Fenstergitter: ab 1500 mm Laibungshoehe zwei Schloesser statt einem,
  // der Aufpreis gilt je Schloss (rules.oeffnung.schloesser, Martin 09.10.2026). Ohne den Block
  // bleibt es beim Aufpreis einmal je Stueck - wie in Function und Angebots-Workflow.
  function schlossZahl(s) {
    var sl = R.oeffnung && R.oeffnung.schloesser;
    if (!sl) return null;
    return s.hoehe >= Number(sl.ab_hoehe) ? Number(sl.anzahl_ab) : Number(sl.anzahl_unter);
  }
  function oePreis(s) {
    if (!s.oe) return 0;
    var n = schlossZahl(s);
    return Number(s.oe.aufpreis || 0) * (n === null ? 1 : n);
  }

  function price(s) {
    var unit = Number(s.m.grundpreis) + Number(s.m.preis_pro_qm) * (s.breite / 1000) * (s.hoehe / 1000) + Number(s.b.aufpreis || 0) + (s.hl ? Number(s.hl.aufpreis || 0) : 0) + oePreis(s);
    unit = Math.round(unit * 100) / 100;
    var rabatt = 0;
    (R.stueckzahl.staffel || []).forEach(function (st) { if (s.menge >= st.ab) rabatt = st.prozent; });
    var rabattiert = Math.round(unit * (1 - rabatt / 100) * 100) / 100;
    // Länderpreis wie in der Function: jede Komponente einzeln umrechnen und runden
    unit = Math.round(unit * TAXF * 100) / 100;
    rabattiert = Math.round(rabattiert * TAXF * 100) / 100;
    var setL = Math.round(setPreis(s) * TAXF * 100) / 100;
    var balkone = Math.round(rabattiert * s.menge * 100) / 100;
    var sets = Math.round(setL * s.menge * 100) / 100;
    var vorl = !!(R.preis_status === 'vorlaeufig' || s.m.vorlaeufig || s.b.vorlaeufig || (s.hl && s.hl.vorlaeufig) || (s.oe && s.oe.vorlaeufig));
    return { unit: unit, rabattiert: rabattiert, rabatt: rabatt, balkone: balkone, sets: sets, total: Math.round((balkone + sets) * 100) / 100, vorlaeufig: vorl };
  }

  function properties(s, p) {
    var props = {};
    props[R.familie_key] = R.modell;
    props[R.material.key] = s.m.label;
    props[R.breite.key] = s.breite + ' mm';
    // Bei festem Mass (Fensterstangen) ist die Hoehe reine Rechengroesse fuer die Formel je
    // laufendem Meter, kein Fertigungsmass - sie hat im Warenkorb, im Auftrag und auf den
    // Werkstattpapieren nichts zu suchen (Vorgabe Martin 09.09.2026). Die Function nimmt
    // in diesem Fall rules.hoehe.default aus custom.km_regeln.
    if (!R.hoehe.fest) props[R.hoehe.key] = s.hoehe + ' mm';
    props[R.befestigung.key] = s.b.label;
    if (s.m.farbe && s.farbe) props[R.farbe.key] = farbText(s);
    if (s.hl) props[R.handlauf.key] = s.hl.label;
    // Abgewaehlte Oeffnung ("Ohne") faellt weg (Martin 22.09.2026). Das Befestigungsset "Ohne" bleibt:
    // dort sagt die Zeile der Werkstatt und dem Versand, dass nichts mitgeliefert wird.
    if (s.oe && R.oeffnung && s.oe.id !== 'ohne') {
      props[R.oeffnung.key] = s.oe.label;
      var sz = schlossZahl(s);
      if (sz !== null) props['Anzahl Schlösser'] = String(sz);
    }
    // Keine Betraege in den Positionstext: die Zeile laeuft bis in Auftrag und Werkstattpapiere,
    // dort haben Preise nichts zu suchen. Der Prozentsatz bleibt, damit der Kunde im Warenkorb
    // sieht, dass seine Staffel gegriffen hat.
    if (p.rabatt) props['Mengenrabatt'] = '−' + p.rabatt + ' %';
    // Label unveraendert lassen - die Function erkennt das Set daran. Die Zahl der
    // Befestigungspunkte kommt als eigene Zeile dazu, die Werkstatt legt danach die Laschen fest.
    props[R.sets.key] = s.s.label;
    var pz = punkteZahl(s);
    if (pz !== null && s.s.punkte) props['Befestigungspunkte'] = String(pz);
    // Fertigungsstart muss in den Auftrag: die Werkstatt darf nicht auf eine Freigabe
    // warten, die der Kunde bewusst abgewaehlt hat.
    // Wo es keine Freigabezeichnung gibt (Fensterstangen), waere die Zeile im Auftrag eine
    // leere Aussage - dann bleibt sie weg.
    if (R.fertigungsstart !== false) {
      props['Fertigungsstart'] = s.fertigungsstart === 'sofort'
        ? 'Sofort fertigen – ohne Freigabezeichnung, Maße wie bestellt'
        : 'Erst nach Freigabe der Maßzeichnung';
    }
    if (s.bemerkung) props[R.bemerkung.key] = s.bemerkung;
    // Bild der gewaehlten Kombination fuer den Warenkorb. Versteckte Property, wird
    // in der Positionsliste nicht angezeigt, aber von den Cart-Sections als Bild genutzt.
    var bildId = MEDIA[s.befestigung + '|' + s.material];
    var bildUrl = bildId ? MEDIA_URL[bildId] : null;
    if (bildUrl) props['_km_bild'] = bildUrl;
    props['_km_preis'] = p.total.toFixed(2);
    props['_km_einzelpreis'] = p.unit.toFixed(2);
    props['_km_konfig'] = encode(s);
    return props;
  }

  // Der Deep-Link #konf= wird bei jeder Eingabe neu gesetzt. Ungedrosselt heisst das
  // beim Tippen einer Massangabe mehrere replaceState pro Sekunde - Safari wirft ab
  // rund 100 Aufrufen in 30 Sekunden einen SecurityError und der Konfigurator bricht
  // ab. Deshalb nur der letzte Stand einer halben Sekunde landet in der URL.
  var nutzerAendert = false; // Deep-Link erst schreiben, wenn der Besucher etwas geaendert hat
  var linkTimer = null;
  function deepLink(s) {
    if (!nutzerAendert) return;
    if (linkTimer) clearTimeout(linkTimer);
    linkTimer = setTimeout(function () {
      linkTimer = null;
      try { history.replaceState(null, '', location.pathname + location.search + '#konf=' + encode(s)); } catch (e) {}
    }, 500);
  }

  // Materialwechsel per Deep-Link: Die Links zeigen auf das Schwesterprodukt und
  // tragen die aktuelle Konfiguration im Hash. Auf der Zielseite liest restore() sie
  // ein; das Material selbst wird dort ignoriert, weil es fest zur Seite gehoert -
  // genau so soll es sein.
  var wechselLinks = root.querySelectorAll('[data-km-material][data-km-basis]');
  function wechselAktualisieren(s) {
    if (!wechselLinks.length) return;
    for (var i = 0; i < wechselLinks.length; i++) {
      var a = wechselLinks[i];
      var kopie = {
        material: a.getAttribute('data-km-material'),
          farbe: s.farbe, farbe_wunsch: s.farbe_wunsch, breite: s.breite, hoehe: s.hoehe,
        befestigung: s.befestigung, handlauf: s.handlauf,
        menge: s.menge, set: s.set, bemerkung: s.bemerkung
      };
      a.setAttribute('href', a.getAttribute('data-km-basis') + '#konf=' + encode(kopie));
    }
  }

  function encode(s) {
    return btoa(unescape(encodeURIComponent(JSON.stringify({ m: s.material, f: s.farbe, fw: s.farbe_wunsch, b: s.breite, h: s.hoehe, bf: s.befestigung, hl: s.handlauf, oe: s.oeffnung, q: s.menge, st: s.set, bm: s.bemerkung })))).replace(/=+$/, '');
  }
  function decode(str) {
    try { return JSON.parse(decodeURIComponent(escape(atob(str)))); } catch (e) { return null; }
  }

  // Groessenabhaengige Set-Preise in den Karten mitziehen: bei den Fenstergittern aendert
  // sich der Preis, sobald die Laibungshoehe die Grenze fuer sechs Befestigungspunkte reisst.
  function setPreiseAnzeigen(s) {
    var n = punkteZahl(s);
    if (n === null) return;
    root.querySelectorAll('[data-setpreis]').forEach(function (el) {
      // Punkte-Tabelle je Set als JSON am Element - die Zahlen sind je Familie verschieden.
      var tab = null;
      try { tab = JSON.parse(el.getAttribute('data-punkte') || 'null'); } catch (e) { tab = null; }
      // Sets ohne Punkte-Tabelle (Absturzsicherung) tragen ihren Festpreis am Element.
      var v = tab && tab[String(n)] ? tab[String(n)].preis : (el.getAttribute('data-preis') || el.getAttribute('data-p' + n));
      if (v === null || v === undefined) return;
      // Die Menge im Set haengt an der Zahl der Befestigungspunkte. Wer sie sieht, versteht,
      // warum derselbe Artikel ab 1500 mm Hoehe mehr kostet - und kann gegenrechnen.
      el.textContent = n + ' Befestigungspunkte · + ' + fmt(Number(v)) + ' je ' + ((R.sets && R.sets.einheit) || 'Gitter');
    });
    // Foto zur Menge: vier bzw. sechs Schrauben mit Duebel und Einschlagstern.
    var bilder = (R.sets.punkte || {}).bilder;
    var bild = bilder && bilder[String(n)];
    if (!bild) return;
    root.querySelectorAll('[data-setbild]').forEach(function (el) {
      if (el.getAttribute('src') !== bild) el.src = bild;
    });
  }

  // Kartenpreis der Oeffnungsfunktion: Schlosszahl und Aufpreis zur eingegebenen Hoehe.
  function oePreiseAnzeigen(s) {
    var n = schlossZahl(s);
    if (n === null) return;
    // Die Karte rendert das Snippet mit "+ 180,00 € je Stück"; Betrag und Text kommen hier
    // aus dem Regelwerk, damit das Snippet unveraendert bleiben kann.
    root.querySelectorAll('input[name="oeffnung"]').forEach(function (inp) {
      var o = findeId(R.oeffnung.optionen, inp.value);
      var el = inp.closest('label') && inp.closest('label').querySelector('.km-card__price');
      if (!o || !el || !(Number(o.aufpreis) > 0)) return;
      el.textContent = (n === 1 ? '1 Schloss' : n + ' Schlösser') + ' · + ' + fmt(Number(o.aufpreis) * n) + ' je Gitter';
    });
  }

  // Fenstergitter: die Funktion zum Oeffnen gibt es nur bei Wandmontage vorgesetzt, nicht in
  // der Laibung (Martin 09.10.2026). Bei "In der Laibung" wird die Option gesperrt und auf
  // "Ohne" zurueckgesetzt - sonst landet eine Ausfuehrung im Auftrag, die wir nicht fertigen.
  function oeffnungSperre(s) {
    if (!R.oeffnung) return;
    var gesperrt = s.befestigung === 'laibung';
    root.querySelectorAll('input[name="oeffnung"]').forEach(function (inp) {
      if (inp.value === 'ohne') return;
      inp.disabled = gesperrt;
      if (gesperrt && inp.checked) {
        inp.checked = false;
        var ohne = root.querySelector('input[name="oeffnung"][value="ohne"]');
        if (ohne) ohne.checked = true;
      }
      var lab = inp.closest('label');
      if (!lab) return;
      lab.style.opacity = gesperrt ? '0.45' : '';
      lab.style.cursor = gesperrt ? 'not-allowed' : '';
      var hint = lab.querySelector('[data-km-oe-sperre]');
      if (gesperrt && !hint) {
        hint = document.createElement('small');
        hint.setAttribute('data-km-oe-sperre', '');
        hint.textContent = 'Nur bei Wandmontage vorgesetzt möglich';
        var txt = lab.querySelector('.km-card__text');
        if (txt) txt.appendChild(hint);
      }
      if (hint) hint.hidden = !gesperrt;
    });
  }

  function renderHandlauf(s) {
    var wrap = els.handlauf.closest('fieldset');
    if (!s.m.handlauf || !R.handlauf || !R.handlauf.varianten[s.m.handlauf]) { wrap.hidden = true; els.handlauf.innerHTML = ''; return; }
    var list = R.handlauf.varianten[s.m.handlauf];
    var current = s.handlauf;
    var html = '';
    list.forEach(function (o, i) {
      var checked = current ? (o.label === current) : i === 0;
      var foto = (IMG.handlauf || {})[o.bild];
      html += '<label class="km-card"><input type="radio" name="handlauf" value="' + o.label.replace(/"/g, '&quot;') + '"' + (checked ? ' checked' : '') + '><span class="km-card__body">' +
        (foto ? '<img class="km-card__photo" src="' + foto + '" alt="" width="64" height="64" loading="lazy">' : '') +
        '<span class="km-card__text">' + o.label + (o.aufpreis ? ' (+ ' + fmt(o.aufpreis) + ')' : '') + '</span></span></label>';
    });
    els.handlauf.innerHTML = html; wrap.hidden = false;
  }

  function drawSchema(s) {
    // Quadratisch, weil die Produktgalerie im 1:1-Rahmen mit object-fit:cover anzeigt -
    // ein Querformat wuerde links und rechts beschnitten (Hoehenbemassung faellt weg).
    var W = 940, H = 940;
    // Aufteilung nach der Werkzeichnung von Kirchberger: oben zwei Bemassungsketten
    // (Befestigungsabstand ueber Laibungsbreite), darunter die Ansicht, unten der
    // Stababstand. y0 ist die Oberkante des Gelaenders.
    var y0 = 205;
    var availW = 660, availH = H - y0 - 190;
    var scale = Math.min(availW / s.breite, availH / s.hoehe);
    var bw = s.breite * scale, bh = s.hoehe * scale;
    y0 += (availH - bh) / 2;                       // Ansicht im Restraum vertikal zentrieren
    var x0 = 130 + (availW - bw) / 2, y1 = y0 + bh; // Unterkante Untergurt
    var g = R.geometrie || {}; var maxGap = g.stababstand_max || 120; var over = (g.ueberstand_vorgesetzt || 100) * scale;
    var inLaibung = s.befestigung === 'laibung';
    var winX0 = inLaibung ? x0 : x0 + over, winX1 = inLaibung ? x0 + bw : x0 + bw - over;
    // Zwei Bauarten: Lyon hat Handlauf und zwei Rundrohr-Gurte, Marseille einen umlaufenden
    // Flachstahlrahmen mit senkrechten Flachstaeben. Steuernd ist geometrie.rahmen_flach.
    var rahmen = g.rahmen_flach;
    var rahmenModus = !!(rahmen && rahmen.length === 2);
    // Flachstahl 40x10 steht hochkant: in der Ansicht sind 10 mm sichtbar, 40 mm ist die
    // Tiefe. Deshalb rahmen[1] fuer die Ansichtsbreite (Quelle: Werks-DXF Marseille).
    var rwMm = rahmen ? (rahmen[1] || rahmen[0]) : 0;
    var rw = rahmenModus ? Math.max(3, rwMm * scale) : 0;
    var riegel2Mm = rahmenModus ? (g.riegel_oben_abstand || 0) : 0;
    var mitHandlauf = !rahmenModus && g.handlauf !== false;
    var hlD = rahmenModus ? rw : Math.max(6, (g.handlauf_d || 42) * scale);
    var ugD = rahmenModus ? rw : Math.max(5, (g.gurt_d || 33) * scale);
    var yHl = rahmenModus ? y0 + rw / 2 : (mitHandlauf ? y0 + hlD / 2 : y0 + ugD / 2);
    // Marseille 2: zweiter Flachstahlriegel mit 80 mm lichtem Abstand unter dem obersten.
    var yR2 = riegel2Mm ? y0 + rw + riegel2Mm * scale + rw / 2 : null;
    var yStabTop = (yR2 !== null ? yR2 : yHl) + rw / 2;
    var yOgTop = rahmenModus ? y0 + rw : (mitHandlauf ? y0 + hlD + (g.handlauf_abstand || 80) * scale : y0);
    var yOg = rahmenModus ? yHl : (mitHandlauf ? yOgTop + ugD / 2 : y0 + ugD / 2);
    var yUg = y1 - ugD / 2;
    var tiefeMm = inLaibung ? (g.tiefe_laibung || 40) : (g.tiefe_vorgesetzt || 80);
    var winBot = y1 + Math.max(22, 50 * scale); // Unterkante Fensteröffnung (max. 50 mm unter dem Geländer)
    // Aussenkanten des Bauteils gegenueber dem Befestigungsabstand. Werte fuer die
    // Rahmenbauart aus der Werks-DXF: vorgesetzt sitzt die Bohrung 42,5 mm von der
    // Rahmenaussenkante, in der Laibung ist der Rahmen je Seite 5 mm schmaler.
    var luftMm = g.laibung_luft || 5;
    var randMm = g.bohrung_rand_vorgesetzt || 42.5;
    var ext;
    if (rahmenModus) ext = (inLaibung ? -luftMm : randMm) * scale;
    else ext = inLaibung ? 0 : 25 * scale;     // Gurtueberstand Lyon: Bohrung 25 mm von aussen
    var gx0 = x0 - ext, gx1 = x0 + bw + ext;   // Aussenkanten Rahmen bzw. Handlauf/Gurte
    var rahmenBreiteMm = inLaibung ? (s.breite - 2 * luftMm) : (s.breite + 2 * randMm);
    var inset = 50 * scale;                     // erster Stab 50 mm von außen eingerückt
    var bx0 = gx0 + inset, bx1 = gx1 - inset;
    var col = s.material === 'edelstahl' ? '#9ca3af' : (s.material === 'pulverbeschichtet' ? '#374151' : '#6b7280');
    var dim = '#01014d', sub = '#374151';
    var out = '';
    out += '<rect x="0" y="0" width="' + W + '" height="' + H + '" fill="#fff"/>';
    // Wand + Fenster (Frontansicht)
    var winTop = y0 - 65; // Oberkante der dargestellten Fensteroeffnung
    out += '<rect x="' + (winX0 - 60) + '" y="' + winTop + '" width="' + (winX1 - winX0 + 120) + '" height="' + (winBot + 20 - winTop) + '" fill="#e5e7eb"/>';
    out += '<rect x="' + winX0 + '" y="' + winTop + '" width="' + (winX1 - winX0) + '" height="' + (winBot - winTop) + '" fill="#bfdbfe" stroke="#64748b" stroke-width="3"/>';
    if (rahmenModus) {
      // Umlaufender Rahmen: oben, unten und die beiden senkrechten Profile.
      out += '<line x1="' + gx0 + '" y1="' + yHl + '" x2="' + gx1 + '" y2="' + yHl + '" stroke="' + col + '" stroke-width="' + rw + '"/>';
      out += '<line x1="' + gx0 + '" y1="' + yUg + '" x2="' + gx1 + '" y2="' + yUg + '" stroke="' + col + '" stroke-width="' + rw + '"/>';
      out += '<line x1="' + (gx0 + rw / 2) + '" y1="' + y0 + '" x2="' + (gx0 + rw / 2) + '" y2="' + y1 + '" stroke="' + col + '" stroke-width="' + rw + '"/>';
      out += '<line x1="' + (gx1 - rw / 2) + '" y1="' + y0 + '" x2="' + (gx1 - rw / 2) + '" y2="' + y1 + '" stroke="' + col + '" stroke-width="' + rw + '"/>';
      if (yR2 !== null) {
        out += '<line x1="' + gx0 + '" y1="' + yR2 + '" x2="' + gx1 + '" y2="' + yR2 + '" stroke="' + col + '" stroke-width="' + rw + '"/>';
      }
    } else {
      // Gelaender: Handlauf (Oberkante = y0), Obergurt, Untergurt (Unterkante = y1).
      // Basic und Basic 2 haben laut Produkttext keinen Handlauf - dann faellt die Zeile weg
      // und der Obergurt rueckt an die Oberkante.
      // Werkzeichnung: der Handlauf steht seitlich ueber die Gurte hinaus, alle Rohre
      // sind an den Enden gerundet (Kappe).
      if (mitHandlauf) {
        var hlExt = hlD * 0.6;
        out += '<line x1="' + (gx0 - hlExt) + '" y1="' + yHl + '" x2="' + (gx1 + hlExt) + '" y2="' + yHl + '" stroke="' + col + '" stroke-width="' + hlD + '" stroke-linecap="round"/>';
      }
      out += '<line x1="' + gx0 + '" y1="' + yOg + '" x2="' + gx1 + '" y2="' + yOg + '" stroke="' + col + '" stroke-width="' + ugD + '" stroke-linecap="round"/>';
      out += '<line x1="' + gx0 + '" y1="' + yUg + '" x2="' + gx1 + '" y2="' + yUg + '" stroke="' + col + '" stroke-width="' + ugD + '" stroke-linecap="round"/>';
    }
    // Fuellstaebe: Abstand <= maxGap, gleichmaessig verteilt
    var fields, gap, i, x;
    if (rahmenModus) {
      // Stabfeld ist das lichte Mass zwischen den senkrechten Rahmenprofilen.
      // Lichte Weite zwischen den senkrechten Holmen, gleichmaessig geteilt - auch die
      // beiden Randfelder. Feldzahl nach dem lichten Abstand: (licht + s) / (max + s).
      bx0 = gx0 + rw; bx1 = gx1 - rw;
      var stabMm = (g.fuellstab_flach && (g.fuellstab_flach[1] || g.fuellstab_flach[0])) || 6;
      var lichtMm = Math.max(1, rahmenBreiteMm - 2 * rwMm);
      fields = Math.max(1, Math.ceil((lichtMm + stabMm) / (maxGap + stabMm)));
      gap = (bx1 - bx0) / fields;
      var stabW = Math.max(2, stabMm * scale);
      for (i = 1; i < fields; i++) {
        x = bx0 + i * gap;
        out += '<line x1="' + x + '" y1="' + yStabTop + '" x2="' + x + '" y2="' + (yUg - rw / 2) + '" stroke="' + col + '" stroke-width="' + stabW + '"/>';
      }
      // Senkrechte Mittelstrebe ab der im Produkttext genannten Breite (Marseille 2).
      if (g.mittelstrebe_ab && s.breite > g.mittelstrebe_ab) {
        var xm = (gx0 + gx1) / 2;
        out += '<line x1="' + xm + '" y1="' + y0 + '" x2="' + xm + '" y2="' + y1 + '" stroke="' + col + '" stroke-width="' + rw + '"/>';
      }
    } else {
      var spanMm = s.breite + (inLaibung ? 0 : 50) - 100; // Stabfeld: Gurtlaenge minus 2 x 50 mm Einrueckung
      fields = Math.max(1, Math.ceil(spanMm / maxGap)); gap = (bx1 - bx0) / fields;
      for (i = 0; i <= fields; i++) {
        x = bx0 + i * gap;
        var halter = mitHandlauf && (i === 1 || i === fields - 1); // Handlaufhalter: zweiter Stab von aussen
        out += '<line x1="' + x + '" y1="' + (halter ? yHl : yOg) + '" x2="' + x + '" y2="' + yUg + '" stroke="' + col + '" stroke-width="' + Math.max(3, (g.fuellstab_d || 12) * scale) + '"/>';
      }
    }
    // Befestigungspunkte (Lochmitte = Messpunkt); beim Winkel als Platte mit Bohrung
    if (rahmenModus) {
      // Masse aus der Werks-DXF: in der Laibung sitzt der Einschiebling 50 mm von Ober-
      // und Unterkante im senkrechten Holm. Vorgesetzt traegt ein 5-mm-Kantblech
      // (40 mm hoch) die Bohrung, 70 mm von der Kante des tragenden Riegels.
      if (inLaibung) {
        var eY = [y0 + (g.laibung_bohrung_rand || 50) * scale, y1 - (g.laibung_bohrung_rand || 50) * scale];
        [gx0 + rw / 2, gx1 - rw / 2].forEach(function (x) {
          eY.forEach(function (y) {
            out += '<circle cx="' + x + '" cy="' + y + '" r="' + Math.max(3, rw * 0.45) + '" fill="#fff" stroke="#4b5563" stroke-width="1.8"/>';
          });
        });
      } else {
        var bh = (g.bohrung_hoehe || 70) * scale;
        var lh = Math.max(7, 40 * scale);       // Kantblech 40 mm hoch
        var la = Math.max(10, 52.5 * scale);    // Ausladung ab Rahmeninnenkante
        var bY = [(yR2 !== null ? yR2 - rw / 2 : y0) + bh, y1 - bh];
        [[gx0 + rw, 1], [gx1 - rw, -1]].forEach(function (p) {
          var xk = p[0], dir = p[1];
          bY.forEach(function (y) {
            out += '<rect x="' + (dir > 0 ? xk : xk - la) + '" y="' + (y - lh / 2) + '" width="' + la + '" height="' + lh + '" fill="#fff" stroke="' + col + '" stroke-width="2"/>';
          });
        });
        [x0, x0 + bw].forEach(function (x) {
          bY.forEach(function (y) {
            out += '<circle cx="' + x + '" cy="' + y + '" r="' + Math.max(2.5, rw * 0.5) + '" fill="#fff" stroke="#4b5563" stroke-width="1.8"/>';
            out += '<circle cx="' + x + '" cy="' + y + '" r="2" fill="' + dim + '"/>';
          });
        });
      }
    }
    if (!inLaibung && !rahmenModus) {
      [x0, x0 + bw].forEach(function (x) {
        [yOg, yUg].forEach(function (y) {
          if (s.befestigung === 'vorgesetzt-winkel') {
            var up = (y === yUg); // Untergurt: Platte oberhalb, Obergurt: unterhalb (Schenkel zeigen zur Mitte)
            var py = up ? (y - ugD / 2 - 19) : (y + ugD / 2 - 1);
            var hy = up ? (y - ugD / 2 - 9) : (y + ugD / 2 + 9);
            out += '<rect x="' + (x - 9) + '" y="' + py + '" width="18" height="20" rx="5" fill="#fff" stroke="' + col + '" stroke-width="3"/>';
            out += '<circle cx="' + x + '" cy="' + hy + '" r="3" fill="#fff" stroke="' + col + '" stroke-width="2"/>';
          } else {
            // Wandteller wie in der Werkzeichnung: Flansch mit Bohrung, Lochmitte = Messpunkt
            out += '<circle cx="' + x + '" cy="' + y + '" r="' + Math.max(6, ugD * 0.5) + '" fill="#fff" stroke="' + col + '" stroke-width="2.5"/>';
            out += '<circle cx="' + x + '" cy="' + y + '" r="3.5" fill="' + dim + '"/>';
          }
        });
      });
    }
    // --- Bemassung oben, wie in der Werkzeichnung: Befestigungsabstand ueber Laibungsbreite ---
    var yBef = y0 - 109;   // Kette 1: Befestigungsabstand (Lochmitte zu Lochmitte)
    var yLai = y0 - 65;    // Kette 2: Laibungsbreite
    // Hilfslinien von den Messpunkten nach oben
    [x0, x0 + bw].forEach(function (x) {
      out += '<line x1="' + x + '" y1="' + (yBef - 12) + '" x2="' + x + '" y2="' + (y0 - 4) + '" stroke="#9ca3af" stroke-width="1"/>';
    });
    if (!inLaibung) {
      [winX0, winX1].forEach(function (x) {
        out += '<line x1="' + x + '" y1="' + (yLai - 12) + '" x2="' + x + '" y2="' + (y0 - 4) + '" stroke="#9ca3af" stroke-width="1"/>';
      });
    }
    out += '<line x1="' + x0 + '" y1="' + yBef + '" x2="' + (x0 + bw) + '" y2="' + yBef + '" stroke="' + dim + '" stroke-width="2" marker-start="url(#km-arr)" marker-end="url(#km-arr)"/>';
    out += '<text x="' + (x0 + bw / 2) + '" y="' + (yBef - 12) + '" text-anchor="middle" font-size="26" font-family="system-ui, sans-serif" fill="' + dim + '" font-weight="600">Befestigungsabstand ' + s.breite + ' mm</text>';
    out += '<line x1="' + winX0 + '" y1="' + yLai + '" x2="' + winX1 + '" y2="' + yLai + '" stroke="' + sub + '" stroke-width="2" marker-start="url(#km-arr-s)" marker-end="url(#km-arr-s)"/>';
    if (winX1 - winX0 > 140) {
      out += '<text x="' + ((winX0 + winX1) / 2) + '" y="' + (yLai - 10) + '" text-anchor="middle" font-size="18" font-family="system-ui, sans-serif" fill="' + sub + '">Laibungsbreite</text>';
    }
    if (!inLaibung) {
      // Ueberstand je Seite, wie im Original links neben der Laibungskette
      out += '<line x1="' + x0 + '" y1="' + yLai + '" x2="' + winX0 + '" y2="' + yLai + '" stroke="' + sub + '" stroke-width="2" marker-start="url(#km-arr-s)" marker-end="url(#km-arr-s)"/>';
      out += '<line x1="' + winX1 + '" y1="' + yLai + '" x2="' + (x0 + bw) + '" y2="' + yLai + '" stroke="' + sub + '" stroke-width="2" marker-start="url(#km-arr-s)" marker-end="url(#km-arr-s)"/>';
      out += '<text x="' + (x0 - 10) + '" y="' + (yLai + 6) + '" text-anchor="end" font-size="17" font-family="system-ui, sans-serif" fill="' + sub + '">ca. ' + (g.ueberstand_vorgesetzt || 100) + ' mm</text>';
    }
    // Bemaßung Höhe (Gesamthöhe, Außenkanten)
    var dx = x0 - 64;
    out += '<line x1="' + (gx0 - 6) + '" y1="' + y0 + '" x2="' + (dx - 10) + '" y2="' + y0 + '" stroke="' + dim + '" stroke-width="1"/>';
    out += '<line x1="' + (gx0 - 6) + '" y1="' + y1 + '" x2="' + (dx - 10) + '" y2="' + y1 + '" stroke="' + dim + '" stroke-width="1"/>';
    out += '<line x1="' + dx + '" y1="' + y0 + '" x2="' + dx + '" y2="' + y1 + '" stroke="' + dim + '" stroke-width="2" marker-start="url(#km-arr)" marker-end="url(#km-arr)"/>';
    out += '<text transform="translate(' + (dx - 18) + ' ' + ((y0 + y1) / 2) + ') rotate(-90)" text-anchor="middle" font-size="26" font-family="system-ui, sans-serif" fill="' + dim + '" font-weight="600">Höhe ' + s.hoehe + ' mm</text>';
    // Lichter Abstand Handlauf/Obergurt - in der Werkzeichnung rechts an der Ansicht
    if (mitHandlauf) {
      var xLicht = x0 + bw + 30;
      out += '<line x1="' + (gx1 + 6) + '" y1="' + (y0 + hlD) + '" x2="' + (xLicht + 10) + '" y2="' + (y0 + hlD) + '" stroke="#9ca3af" stroke-width="1"/>';
      out += '<line x1="' + (gx1 + 6) + '" y1="' + yOgTop + '" x2="' + (xLicht + 10) + '" y2="' + yOgTop + '" stroke="#9ca3af" stroke-width="1"/>';
      out += '<line x1="' + xLicht + '" y1="' + (y0 + hlD) + '" x2="' + xLicht + '" y2="' + yOgTop + '" stroke="' + dim + '" stroke-width="2" marker-start="url(#km-arr-s)" marker-end="url(#km-arr-s)"/>';
      out += '<text transform="translate(' + (xLicht + 22) + ' ' + ((y0 + hlD + yOgTop) / 2) + ') rotate(-90)" text-anchor="middle" font-size="17" font-family="system-ui, sans-serif" fill="' + sub + '">' + (g.handlauf_abstand || 80) + ' mm licht</text>';
    }
    // max. 50 mm: Unterkante Geländer bis Unterkante Fensteröffnung
    // Die Strecke ist zu kurz fuer Pfeile innerhalb der Masslinie - wie in der Werkzeichnung
    // stehen die Pfeile aussen und der Text darunter.
    var xUnter = x0 - 14;
    out += '<line x1="' + xUnter + '" y1="' + (y1 - 26) + '" x2="' + xUnter + '" y2="' + y1 + '" stroke="' + dim + '" stroke-width="2" marker-end="url(#km-arr-s)"/>';
    out += '<line x1="' + xUnter + '" y1="' + (winBot + 26) + '" x2="' + xUnter + '" y2="' + winBot + '" stroke="' + dim + '" stroke-width="2" marker-end="url(#km-arr-s)"/>';
    out += '<line x1="' + (xUnter - 8) + '" y1="' + y1 + '" x2="' + (x0 + 4) + '" y2="' + y1 + '" stroke="#9ca3af" stroke-width="1"/>';
    out += '<line x1="' + (xUnter - 8) + '" y1="' + winBot + '" x2="' + (winX0 + 4) + '" y2="' + winBot + '" stroke="#9ca3af" stroke-width="1"/>';
    out += '<text x="' + (xUnter - 10) + '" y="' + (winBot + 8) + '" text-anchor="end" font-size="15" font-family="system-ui, sans-serif" fill="' + sub + '">max. ' + (g.bodenabstand_max || 50) + ' mm</text>';
    // Stababstand zwischen zwei mittleren Stäben (unten)
    var m = Math.max(0, Math.floor((fields - 1) / 2));
    var xA = bx0 + m * gap, xB = xA + gap;
    out += '<line x1="' + xA + '" y1="' + (yUg + ugD / 2 + 4) + '" x2="' + xA + '" y2="' + (winBot + 30) + '" stroke="' + dim + '" stroke-width="1"/>';
    out += '<line x1="' + xB + '" y1="' + (yUg + ugD / 2 + 4) + '" x2="' + xB + '" y2="' + (winBot + 30) + '" stroke="' + dim + '" stroke-width="1"/>';
    out += '<line x1="' + xA + '" y1="' + (winBot + 22) + '" x2="' + xB + '" y2="' + (winBot + 22) + '" stroke="' + dim + '" stroke-width="2" marker-start="url(#km-arr)" marker-end="url(#km-arr)"/>';
    out += '<text x="' + (xB + 12) + '" y="' + (winBot + 28) + '" font-size="18" font-family="system-ui, sans-serif" fill="' + sub + '">max. ' + maxGap + ' mm</text>';
    // Seitenansicht (rechts, gleiche Höhenlage wie die Frontansicht)
    var xWand = 872;                            // Wandflaeche in der Seitenansicht
    var xs = xWand - 28;                        // Rohrachse (Gurtbauart) davor
    if (!inLaibung && !rahmenModus) {
      out += '<rect x="' + xWand + '" y="' + (y0 - 19) + '" width="34" height="' + (winBot + 39 - y0) + '" fill="#e5e7eb"/>';
      if (s.befestigung === 'vorgesetzt-winkel') {
        // Winkel: am Gurt angeschweißt, Wandschenkel oben nach unten / unten nach oben gebogen
        out += '<path d="M ' + (xs + 2) + ' ' + yOg + ' L ' + (xWand - 3) + ' ' + yOg + ' L ' + (xWand - 3) + ' ' + (yOg + 26) + '" fill="none" stroke="' + col + '" stroke-width="5" stroke-linejoin="round"/>';
        out += '<path d="M ' + (xs + 2) + ' ' + yUg + ' L ' + (xWand - 3) + ' ' + yUg + ' L ' + (xWand - 3) + ' ' + (yUg - 26) + '" fill="none" stroke="' + col + '" stroke-width="5" stroke-linejoin="round"/>';
      } else {
        // Abstandshalter: Bolzen mit Wandteller
        [yOg, yUg].forEach(function (y) {
          out += '<line x1="' + xs + '" y1="' + y + '" x2="' + (xWand - 2) + '" y2="' + y + '" stroke="' + col + '" stroke-width="9"/>';
          out += '<rect x="' + (xWand - 6) + '" y="' + (y - 11) + '" width="6" height="22" fill="' + col + '"/>';
        });
      }
    } else if (!rahmenModus) {
      // Laibung: Laschen an Ober- und Untergurt
      [yOg, yUg].forEach(function (y) {
        out += '<rect x="' + (xs + 4) + '" y="' + (y - 8) + '" width="32" height="16" rx="8" fill="#fff" stroke="' + col + '" stroke-width="3"/>';
        out += '<circle cx="' + (xs + 27) + '" cy="' + y + '" r="3.5" fill="#fff" stroke="' + col + '" stroke-width="2"/>';
      });
    }
    var tSeiteA = null, tSeiteB = null;
    if (rahmenModus) {
      // Seitenansicht nach der Werks-DXF: das Flacheisen (40 mm tief) steht ueber die volle
      // Hoehe vorne, die Wandflaeche liegt rechts. In der Laibung liegt das Profil direkt an
      // und traegt zwei Bohrungen 50 mm von Ober- und Unterkante. Vorgesetzt sitzt dahinter
      // das 5-mm-Kantblech (40 mm hoch, 40 mm tief) - zusammen die 80 mm Bautiefe.
      var pdMm = rahmen[0] || 40;
      var pd = Math.max(5, pdMm * scale);
      var td = Math.max(pd, tiefeMm * scale);
      var xVorn = xWand - td;                   // Vorderkante des Bauteils
      tSeiteA = xVorn; tSeiteB = xWand;
      out += '<rect x="' + xVorn + '" y="' + y0 + '" width="' + pd + '" height="' + (y1 - y0) + '" fill="' + col + '"/>';
      if (inLaibung) {
        var sY = [y0 + (g.laibung_bohrung_rand || 50) * scale, y1 - (g.laibung_bohrung_rand || 50) * scale];
        sY.forEach(function (y) {
          out += '<circle cx="' + (xVorn + pd / 2) + '" cy="' + y + '" r="' + Math.max(2.5, 6 * scale) + '" fill="#fff" stroke="#4b5563" stroke-width="1.6"/>';
        });
      } else {
        var sh = Math.max(7, 40 * scale);       // Kantblech 40 mm hoch
        var sbh = (g.bohrung_hoehe || 70) * scale;
        var sB = [(yR2 !== null ? yR2 - rw / 2 : y0) + sbh, y1 - sbh];
        sB.forEach(function (y) {
          out += '<rect x="' + (xVorn + pd) + '" y="' + (y - sh / 2) + '" width="' + (td - pd) + '" height="' + sh + '" fill="#fff" stroke="' + col + '" stroke-width="2"/>';
          out += '<rect x="' + (xWand - 3) + '" y="' + (y - Math.max(3, 5 * scale)) + '" width="6" height="' + (2 * Math.max(3, 5 * scale)) + '" fill="' + col + '"/>';
        });
        out += '<rect x="' + xWand + '" y="' + (y0 - 20) + '" width="30" height="' + (winBot + 20 - y0 + 20) + '" fill="#e5e7eb"/>';
      }
    } else {
      out += '<line x1="' + xs + '" y1="' + yHl + '" x2="' + xs + '" y2="' + yUg + '" stroke="' + col + '" stroke-width="4"/>';
      // Rechteckrohr-Gurte (Basic 2, Basic 3) im Schnitt als Rechteck, Rundrohr als Kreis.
      var eckig = g.gurt_form === 'rechteck';
      var gurtT = Math.max(5, ((g.gurt_tiefe || 40)) * scale);
      function gurtSchnitt(y) {
        if (eckig) return '<rect x="' + (xs - gurtT / 2) + '" y="' + (y - ugD / 2) + '" width="' + gurtT + '" height="' + ugD + '" fill="' + col + '" stroke="#4b5563" stroke-width="1.5"/>';
        return '<circle cx="' + xs + '" cy="' + y + '" r="' + (ugD / 2) + '" fill="' + col + '" stroke="#4b5563" stroke-width="1.5"/>';
      }
      if (mitHandlauf) {
        out += '<circle cx="' + xs + '" cy="' + yHl + '" r="' + (hlD / 2) + '" fill="' + col + '" stroke="#4b5563" stroke-width="1.5"/>';
      }
      out += gurtSchnitt(yOg);
      out += gurtSchnitt(yUg);
    }
    // Tiefenmass oberhalb der Seitenansicht - Lage und Leserichtung wie in der Werkzeichnung.
    // Rahmenbauart (Marseille): Breite des Flachstahls. Gurtbauart (Lyon): Wand bis Rohrrand.
    var tA, tB, tWert;
    if (rahmenModus && tSeiteA !== null) { tA = tSeiteA; tB = tSeiteB; tWert = tiefeMm; }
    else if (!inLaibung) { tA = xs + ugD / 2; tB = xWand; tWert = (g.wandabstand || 40); }
    if (tA !== undefined) {
      var yTief = y0 - 42;
      out += '<line x1="' + tA + '" y1="' + (yTief - 8) + '" x2="' + tA + '" y2="' + (y0 - 6) + '" stroke="#9ca3af" stroke-width="1"/>';
      out += '<line x1="' + tB + '" y1="' + (yTief - 8) + '" x2="' + tB + '" y2="' + (y0 - 6) + '" stroke="#9ca3af" stroke-width="1"/>';
      if (tB - tA < 30) {
        // Zu kurz fuer Pfeile innerhalb der Masslinie - dann stehen sie aussen.
        out += '<line x1="' + (tA - 26) + '" y1="' + yTief + '" x2="' + tA + '" y2="' + yTief + '" stroke="' + dim + '" stroke-width="2" marker-end="url(#km-arr-s)"/>';
        out += '<line x1="' + (tB + 26) + '" y1="' + yTief + '" x2="' + tB + '" y2="' + yTief + '" stroke="' + dim + '" stroke-width="2" marker-end="url(#km-arr-s)"/>';
      } else {
        out += '<line x1="' + tA + '" y1="' + yTief + '" x2="' + tB + '" y2="' + yTief + '" stroke="' + dim + '" stroke-width="2" marker-start="url(#km-arr-s)" marker-end="url(#km-arr-s)"/>';
      }
      out += '<text x="' + ((tA + tB) / 2) + '" y="' + (yTief - 12) + '" text-anchor="middle" font-size="17" font-family="system-ui, sans-serif" fill="' + sub + '">' + tWert + ' mm</text>';
    }
    var xSeiteMitte = (tSeiteA !== null) ? (tSeiteA + tSeiteB) / 2 : xs;
    out += '<text x="' + xSeiteMitte + '" y="' + (winBot + 72) + '" text-anchor="middle" font-size="15" font-family="system-ui, sans-serif" fill="' + sub + '">Seitenansicht</text>';
    // Detailfoto der gewählten Befestigung (oben rechts)
    var ico = iconDaten((IMG.icons || {})[s.befestigung]);
    if (ico) {
      out += '<rect x="792" y="6" width="136" height="136" fill="#fff" stroke="#d1d5db" rx="8"/>';
      out += '<image href="' + ico + '" x="800" y="14" width="120" height="120" preserveAspectRatio="xMidYMid meet"/>';
    }
    // Infozeile oben
    out += '<text x="435" y="40" text-anchor="middle" font-size="22" font-family="system-ui, sans-serif" fill="' + sub + '" font-weight="600">' + s.b.label + '</text>';
    var defs = '<defs>'
      + '<marker id="km-arr" viewBox="0 0 10 10" refX="10" refY="5" markerWidth="6" markerHeight="6" orient="auto-start-reverse"><path d="M0 0 L10 5 L0 10 z" fill="' + dim + '"/></marker>'
      + '<marker id="km-arr-s" viewBox="0 0 10 10" refX="10" refY="5" markerWidth="6" markerHeight="6" orient="auto-start-reverse"><path d="M0 0 L10 5 L0 10 z" fill="' + sub + '"/></marker>'
      + '</defs>';
    var svgStr = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + W + ' ' + H + '">' + defs + out + '</svg>';
    var url = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgStr);
    if (SK_ID) window.__kmSkizzen[String(SK_ID)] = url;
    var mini = document.getElementById('km-mini-' + sid);
    if (mini) {
      mini.src = url;
      var miniBox = mini.closest('.km-mini');
      if (miniBox) miniBox.hidden = false;
    }
    skizzeTargets().forEach(function (n) {
      n.removeAttribute('srcset'); n.removeAttribute('data-srcset'); n.removeAttribute('sizes');
      if (n.tagName === 'IMG') n.src = url; else n.srcset = url;
    });
  }

  // ---------------------------------------------------------------------------------------
  // Parametrische Massskizze der Fenstergitter (Martin 09.10.2026). Steht im Massschritt an
  // Stelle der festen Werkzeichnung; die Werkzeichnung mit Detail und Schnitt bleibt in der
  // Galerie. Masse aus den Werkzeichnungen von Kirchberger:
  //   vorgesetzt: Rahmen 57 mm ueber die Laibung (seitlich, oben; unten ohne Fensterbrett),
  //               mit Fensterbrett endet der Rahmen 50 mm ueber der Fensterbank,
  //               Laschenloch 80 mm neben der Laibungskante, Lasche ca. 200 mm vom Rahmenende;
  //   Laibung:    Rahmen in der Laibung, Querstab unten 50 mm ueber der Laibungsunterkante.
  // Fuellung je Modell: Pisa waagrecht, alle anderen senkrecht. Zierteile (Korb, Linse, Herzen)
  // zeichnen wir bewusst nicht - die Skizze zeigt Masse und Befestigung, das Modell zeigt die
  // Galerie (Martin 09.10.2026). Stababstand max. 120 mm laut Produktbeschreibung.
  var FG_MODELLE = {
    'Turin': 'senkrecht', 'Pisa': 'waagrecht', 'Mailand': 'senkrecht', 'Mailand 2': 'senkrecht',
    'Venedig': 'senkrecht', 'Venedig 2': 'senkrecht', 'Caorle': 'senkrecht', 'Florenz': 'senkrecht'
  };
  function istGitter() {
    return /Fenstergitter/.test(R.familie_key || '') && !!FG_MODELLE[R.modell];
  }
  function gitterFarbe(s) {
    if (s.m && s.m.farbe && s.farbe && R.farbe && R.farbe.optionen) {
      for (var i = 0; i < R.farbe.optionen.length; i++) {
        var o = R.farbe.optionen[i];
        if (o.label === s.farbe && o.hex) return o.hex;
      }
    }
    return (s.m && s.m.render === 'edelstahl') ? '#b8bec5' : '#9aa1a9';
  }
  function drawGitter(s) {
    var mini = document.getElementById('km-mini-' + sid);
    if (!mini) return;
    var box = mini.closest('.km-mini');
    var B = Number(s.breite) || R.breite.min, H = Number(s.hoehe) || R.hoehe.min;
    var bf = s.befestigung || '';
    var laib = bf === 'laibung', mitFb = bf === 'vorgesetzt-mit-fensterbrett';
    var UE = 57, RAHMEN = 30, STAB = 12, ABST = 120, LOCH = 80, LASCHE = 200, FB = 50;
    // Rahmen in mm, Ursprung = linke obere Laibungsecke
    var fx0, fx1, fy0, fy1;
    if (laib) { fx0 = 20; fx1 = B - 20; fy0 = 50; fy1 = H - 50; }
    else { fx0 = -UE; fx1 = B + UE; fy0 = -UE; fy1 = mitFb ? H - FB : H + UE; }
    var punkte = punkteZahl(s) || 4;
    var nS = schlossZahl(s);
    var offen = !!(s.oe && s.oe.id !== 'ohne');
    // Massstab: Zeichenflaeche 900 px breit, Raender fuer Bemassung
    var W = 720, ML = 100, MR = 130, MT = offen && nS ? 146 : 120, MB = 170;
    var mmB = (fx1 - fx0) + 260, mmH = (fy1 - fy0) + 220;
    var k = Math.min((W - ML - MR) / mmB, 680 / mmH, 1);
    var hPx = Math.round(mmH * k);
    var Hh = Math.max(480, MT + hPx + MB);
    var ox = ML + ((W - ML - MR) - mmB * k) / 2 + 130 * k - fx0 * k;
    var oy = MT + 110 * k - fy0 * k;
    function X(mm) { return Math.round((ox + mm * k) * 10) / 10; }
    function Y(mm) { return Math.round((oy + mm * k) * 10) / 10; }
    var col = gitterFarbe(s), dunkel = '#4b5563', blau = '#1d4ed8', grau = '#6b7280';
    var o = '';
    // Wand, Laibung, Fenster
    o += '<rect x="0" y="0" width="' + W + '" height="' + Hh + '" fill="#f3f4f6"/>';
    o += '<rect x="' + X(0) + '" y="' + Y(0) + '" width="' + (B * k) + '" height="' + (H * k) + '" fill="#ffffff" stroke="#9ca3af" stroke-width="1.5"/>';
    var rand = Math.min(70, B * 0.08, H * 0.08);
    o += '<rect x="' + X(rand) + '" y="' + Y(rand) + '" width="' + ((B - 2 * rand) * k) + '" height="' + ((H - 2 * rand) * k) + '" fill="#c7e0f6" stroke="#9ca3af" stroke-width="1.5"/>';
    if (mitFb) o += '<rect x="' + X(-30) + '" y="' + Y(H) + '" width="' + ((B + 60) * k) + '" height="' + Math.max(6, 35 * k) + '" fill="#2f3440"/>';
    // Laschen (vorgesetzt) bzw. Halteplatten (Laibung); bei Oeffnung links Scharniere, rechts Schloesser
    var yL = [fy0 + LASCHE, fy1 - LASCHE];
    if (fy1 - fy0 < 2 * LASCHE + 60) yL = [fy0 + (fy1 - fy0) * 0.25, fy1 - (fy1 - fy0) * 0.25];
    if (punkte >= 6) yL.splice(1, 0, (yL[0] + yL[1]) / 2);
    var lw = Math.max(4, 40 * k);
    function lasche(seite, y) {
      var xa = seite < 0 ? fx0 : fx1, xb = seite < 0 ? -100 : B + 100, xh = seite < 0 ? -LOCH : B + LOCH;
      var x1 = Math.min(X(xa), X(xb)), w = Math.abs(X(xb) - X(xa));
      return '<rect x="' + x1 + '" y="' + (Y(y) - lw / 2) + '" width="' + w + '" height="' + lw + '" rx="' + (lw / 3) + '" fill="' + col + '" stroke="' + dunkel + '" stroke-width="1"/>' +
        '<circle cx="' + X(xh) + '" cy="' + Y(y) + '" r="' + Math.max(2.5, 6.25 * k) + '" fill="#f3f4f6" stroke="' + dunkel + '" stroke-width="1"/>';
    }
    function scharnier(y) {
      var x = laib ? fx0 : fx0;
      return '<rect x="' + (X(x) - Math.max(5, 14 * k)) + '" y="' + (Y(y) - Math.max(10, 45 * k)) + '" width="' + Math.max(10, 28 * k) + '" height="' + Math.max(20, 90 * k) + '" rx="3" fill="' + col + '" stroke="#111827" stroke-width="2"/>' +
        '<line x1="' + X(x) + '" y1="' + (Y(y) - Math.max(10, 45 * k)) + '" x2="' + X(x) + '" y2="' + (Y(y) + Math.max(10, 45 * k)) + '" stroke="' + dunkel + '" stroke-width="2"/>';
    }
    function schloss(y) {
      var bw = Math.max(12, 40 * k), bh = Math.max(22, 110 * k);
      var x = X(fx1) - bw / 2;
      return '<rect x="' + x + '" y="' + (Y(y) - bh / 2) + '" width="' + bw + '" height="' + bh + '" rx="2" fill="' + col + '" stroke="#111827" stroke-width="2"/>' +
        '<circle cx="' + (x + bw / 2) + '" cy="' + (Y(y) - bh * 0.08) + '" r="' + Math.max(2, bw * 0.13) + '" fill="#111827"/>' +
        '<rect x="' + (x + bw / 2 - Math.max(1, bw * 0.06)) + '" y="' + (Y(y) - bh * 0.08) + '" width="' + Math.max(2, bw * 0.12) + '" height="' + (bh * 0.18) + '" fill="#111827"/>';
    }
    var yS = [];
    if (offen && nS) yS = nS >= 2 ? [yL[0], yL[yL.length - 1]] : [(fy0 + fy1) / 2];
    if (!laib) {
      yL.forEach(function (y) {
        if (!offen) o += lasche(-1, y);
        o += offen ? '' : lasche(1, y);
      });
      if (offen) yL.forEach(function (y) { o += lasche(-1, y); });
    }
    // Rahmen
    var rp = Math.max(4, RAHMEN * k);
    o += '<rect x="' + (X(fx0) + rp / 2) + '" y="' + (Y(fy0) + rp / 2) + '" width="' + ((fx1 - fx0) * k - rp) + '" height="' + ((fy1 - fy0) * k - rp) + '" fill="none" stroke="' + col + '" stroke-width="' + rp + '"/>';
    o += '<rect x="' + X(fx0) + '" y="' + Y(fy0) + '" width="' + ((fx1 - fx0) * k) + '" height="' + ((fy1 - fy0) * k) + '" fill="none" stroke="' + dunkel + '" stroke-width="1"/>';
    o += '<rect x="' + (X(fx0) + rp) + '" y="' + (Y(fy0) + rp) + '" width="' + ((fx1 - fx0) * k - 2 * rp) + '" height="' + ((fy1 - fy0) * k - 2 * rp) + '" fill="none" stroke="' + dunkel + '" stroke-width="1"/>';
    if (laib) {
      // Befestigungslaschen (68 mm hoch) an den Rahmenenden, bei 6 Punkten zusaetzlich mittig.
      // Sie ueberbruecken die 20 mm zur Laibung und sind beweglich (14 mm Einbauspiel, Martin 09.10.2026).
      var yP = [fy0 + 34, fy1 - 34];
      if (punkte >= 6) yP.splice(1, 0, (fy0 + fy1) / 2);
      var ph = Math.max(12, 68 * k), pw = Math.max(5, 20 * k);
      yP.forEach(function (y) {
        o += '<rect x="' + (X(fx0) - pw) + '" y="' + (Y(y) - ph / 2) + '" width="' + pw + '" height="' + ph + '" fill="' + col + '" stroke="' + dunkel + '" stroke-width="1"/>';
        o += '<rect x="' + X(fx1) + '" y="' + (Y(y) - ph / 2) + '" width="' + pw + '" height="' + ph + '" fill="' + col + '" stroke="' + dunkel + '" stroke-width="1"/>';
        // Doppelpfeil: Lasche verschiebbar
        [[X(0) - 38, X(0) - 6], [X(B) + 6, X(B) + 38]].forEach(function (xx) {
          o += '<line x1="' + xx[0] + '" y1="' + Y(y) + '" x2="' + xx[1] + '" y2="' + Y(y) + '" stroke="' + dunkel + '" stroke-width="1.6" marker-start="url(#fg-p)" marker-end="url(#fg-p)"/>';
        });
      });
    }
    // Fuellstaebe: Anzahl so, dass das lichte Mass zwischen den Staeben hoechstens 120 mm betraegt
    var ix0 = fx0 + RAHMEN, ix1 = fx1 - RAHMEN, iy0 = fy0 + RAHMEN, iy1 = fy1 - RAHMEN;
    var sp = Math.max(2.5, STAB * k);
    var staebe = [];
    function stab(x1, y1, x2, y2) {
      return '<line x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '" stroke="' + dunkel + '" stroke-width="' + (sp + 2) + '"/>' +
        '<line x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '" stroke="' + col + '" stroke-width="' + sp + '"/>';
    }
    var waag = FG_MODELLE[R.modell] === 'waagrecht';
    var lang = waag ? (iy1 - iy0) : (ix1 - ix0);
    var n = Math.max(1, Math.ceil((lang - ABST) / (ABST + STAB)));
    var luft = (lang - n * STAB) / (n + 1);
    for (var i = 0; i < n; i++) staebe.push((waag ? iy0 : ix0) + luft * (i + 1) + STAB * i + STAB / 2);
    staebe.forEach(function (p) {
      o += waag ? stab(X(ix0), Y(p), X(ix1), Y(p)) : stab(X(p), Y(iy0), X(p), Y(iy1));
    });
    // Oeffnungsfunktion: Scharniere links, Schloss bzw. Schloesser rechts
    if (offen) {
      o += scharnier(yL[0]) + scharnier(yL[yL.length - 1]);
      yS.forEach(function (y) { o += schloss(y); });
      function marke(x, y, text, anker) {
        return '<text x="' + x + '" y="' + y + '" text-anchor="' + anker + '" font-size="15" font-family="system-ui, sans-serif" font-weight="600" fill="#111827" stroke="#ffffff" stroke-width="4" paint-order="stroke">' + text + '</text>';
      }
      o += marke(X(fx0) + Math.max(14, 30 * k) + 8, Y(yL[0]) + 5, 'Scharnier', 'start');
      o += marke(X(fx0) + Math.max(14, 30 * k) + 8, Y(yL[yL.length - 1]) + 5, 'Scharnier', 'start');
      yS.forEach(function (y) { o += marke(X(fx1) - Math.max(14, 30 * k) - 8, Y(y) + 5, 'Schloss', 'end'); });
    }
    // Bemassung
    function pfeil(x1, y1, x2, y2, farbe, text, vertikal, seite) {
      var r = '<line x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '" stroke="' + farbe + '" stroke-width="1.6" marker-start="url(#fg-p)" marker-end="url(#fg-p)"/>';
      if (vertikal) {
        var tx = x1 + (seite < 0 ? -12 : 14), ty = (y1 + y2) / 2;
        r += '<text x="' + tx + '" y="' + ty + '" transform="rotate(-90 ' + tx + ' ' + ty + ')" text-anchor="middle" font-size="21" font-family="system-ui, sans-serif" fill="' + farbe + '" font-weight="600">' + esc(text) + '</text>';
      } else {
        r += '<text x="' + ((x1 + x2) / 2) + '" y="' + (y1 + (seite < 0 ? -10 : 24)) + '" text-anchor="middle" font-size="21" font-family="system-ui, sans-serif" fill="' + farbe + '" font-weight="600">' + esc(text) + '</text>';
      }
      return r;
    }
    function hilfslinie(x1, y1, x2, y2) { return '<line x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '" stroke="#9ca3af" stroke-width="1" stroke-dasharray="4 3"/>'; }
    var yTop = Math.min(Y(fy0), Y(0)) - 34;
    o += hilfslinie(X(0), Y(0), X(0), yTop - 6) + hilfslinie(X(B), Y(0), X(B), yTop - 6);
    o += pfeil(X(0), yTop, X(B), yTop, blau, 'Laibungsbreite ' + B + ' mm', false, -1);
    var xLeft = Math.min(X(fx0), X(-100)) - 34;
    o += hilfslinie(X(0), Y(0), xLeft - 6, Y(0)) + hilfslinie(X(0), Y(H), xLeft - 6, Y(H));
    o += pfeil(xLeft, Y(0), xLeft, Y(H), blau, 'Laibungshöhe ' + H + ' mm', true, -1);
    if (!laib) {
      // Lochabstand der Befestigungslaschen: waagrecht Laibung + 2 x 80 mm, senkrecht Lasche zu Lasche
      var yUnten = Math.max(Y(fy1), Y(H) + (mitFb ? 35 * k : 0)) + 44;
      var yLoch = yL[yL.length - 1];
      if (!offen) {
        o += hilfslinie(X(-LOCH), Y(yLoch), X(-LOCH), yUnten + 6) + hilfslinie(X(B + LOCH), Y(yLoch), X(B + LOCH), yUnten + 6);
        o += pfeil(X(-LOCH), yUnten, X(B + LOCH), yUnten, dunkel, 'Lochabstand ' + (B + 2 * LOCH) + ' mm', false, 1);
      }
      if (!offen) {
        var xRechts = X(B + 100) + 40, xRef = X(B + LOCH);
        var vy = yL.map(function (y) { return Y(y); });
        var ab = Math.round(yL[yL.length - 1] - yL[0]);
        o += hilfslinie(xRef, vy[0], xRechts + 6, vy[0]) + hilfslinie(xRef, vy[vy.length - 1], xRechts + 6, vy[vy.length - 1]);
        o += pfeil(xRechts, vy[0], xRechts, vy[vy.length - 1], dunkel, 'Lochabstand ca. ' + ab + ' mm', true, -1);
      } else {
        o += '<text x="' + X(B / 2) + '" y="' + yUnten + '" text-anchor="middle" font-size="16" font-family="system-ui, sans-serif" fill="' + grau + '">Lochbild der Ausführung zum Öffnen auf Anfrage</text>';
      }
    } else {
      // Abstaende Rahmen zur Laibung: seitlich je 20 mm, oben und unten je 50 mm
      function strich(x1, y1, x2, y2) { return '<line x1="' + x1 + '" y1="' + y1 + '" x2="' + x2 + '" y2="' + y2 + '" stroke="' + dunkel + '" stroke-width="1.4"/>'; }
      function klein(x, y, text, anker) { return '<text x="' + x + '" y="' + y + '" text-anchor="' + anker + '" font-size="16" font-family="system-ui, sans-serif" font-weight="600" fill="' + dunkel + '">' + text + '</text>'; }
      var yA = Y(H) + 16;
      o += hilfslinie(X(fx0), Y(fy1), X(fx0), yA + 5);
      o += strich(X(0), yA, X(fx0), yA) + strich(X(0), yA - 5, X(0), yA + 5) + strich(X(fx0), yA - 5, X(fx0), yA + 5);
      o += klein(X(0) - 6, yA + 5, '20', 'end');
      var xA = X(B) + 52;
      o += hilfslinie(X(fx1), Y(fy0), xA + 5, Y(fy0)) + hilfslinie(X(fx1), Y(fy1), xA + 5, Y(fy1));
      o += hilfslinie(X(B), Y(0), xA + 5, Y(0)) + hilfslinie(X(B), Y(H), xA + 5, Y(H));
      [[0, fy0], [fy1, H]].forEach(function (a) {
        o += strich(xA, Y(a[0]), xA, Y(a[1])) + strich(xA - 5, Y(a[0]), xA + 5, Y(a[0])) + strich(xA - 5, Y(a[1]), xA + 5, Y(a[1]));
        o += klein(xA + 9, (Y(a[0]) + Y(a[1])) / 2 + 6, '50', 'start');
      });
      var yU = Y(H) + 50;
      o += '<text x="' + X(B / 2) + '" y="' + yU + '" text-anchor="middle" font-size="16" font-family="system-ui, sans-serif" fill="' + grau + '">Rahmen seitlich je 20 mm, oben und unten je 50 mm zur Laibung</text>' +
        '<text x="' + X(B / 2) + '" y="' + (yU + 22) + '" text-anchor="middle" font-size="16" font-family="system-ui, sans-serif" fill="' + grau + '">Befestigungslasche beweglich · 14 mm Einbauspiel</text>';
    }
    // Beschriftung
    var titel = 'Fenstergitter ' + R.modell;
    o += '<text x="' + (W / 2) + '" y="34" text-anchor="middle" font-size="24" font-family="system-ui, sans-serif" fill="#111827" font-weight="600">' + esc(titel) + '</text>';
    var info = [(s.b ? s.b.label : ''), punkte + ' Befestigungspunkte'];
    o += '<text x="' + (W / 2) + '" y="62" text-anchor="middle" font-size="17" font-family="system-ui, sans-serif" fill="' + grau + '">' + esc(info.join(' · ')) + '</text>';
    if (offen && nS) o += '<text x="' + (W / 2) + '" y="86" text-anchor="middle" font-size="17" font-family="system-ui, sans-serif" fill="' + grau + '">' + esc('Zum Öffnen: Scharniere links, ' + (nS === 1 ? '1 Schloss' : nS + ' Schlösser') + ' rechts') + '</text>';
    o += '<text x="' + (W / 2) + '" y="' + (Hh - 40) + '" text-anchor="middle" font-size="15" font-family="system-ui, sans-serif" fill="' + grau + '">Schematische Ansicht von außen</text>';
    o += '<text x="' + (W / 2) + '" y="' + (Hh - 18) + '" text-anchor="middle" font-size="15" font-family="system-ui, sans-serif" fill="' + grau + '">Stababstand max. 120 mm' + (laib ? '' : ' · Laschen ca. 200 mm vom Rahmenende') + '</text>';
    var defs = '<defs><marker id="fg-p" viewBox="0 0 10 10" refX="10" refY="5" markerWidth="7" markerHeight="7" orient="auto-start-reverse"><path d="M0 0 L10 5 L0 10 z" fill="context-stroke"/></marker></defs>';
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + W + ' ' + Hh + '">' + defs + o + '</svg>';
    var url = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
    if (mini.getAttribute('src') !== url) mini.src = url;
    mini.alt = 'Maßskizze ' + titel + ', ' + (s.b ? s.b.label : '') + ', Laibung ' + B + ' × ' + H + ' mm';
    if (box) {
      box.hidden = false;
      box.classList.add('km-mini--immer', 'km-mini--gitter');
      var txt = box.querySelector('.km-mini__text');
      if (txt) txt.textContent = 'Ihre Maße in der Zeichnung · Werkzeichnung mit Schnitt in der Bildergalerie';
    }
  }

  // Ohne parametrische Skizze steht im Massschritt die Werkzeichnung zur gewaehlten
  // Befestigungsart. Sie erklaert, was Laibungsbreite und -hoehe meinen - auf dem Handy
  // unter den Feldern, auf breiten Schirmen daneben. Bisher blieb der Platz leer und der
  // Kunde musste zum Messen in die Galerie hochscrollen.
  function setMiniZeichnung(s) {
    var mini = document.getElementById('km-mini-' + sid);
    if (!mini) return;
    var box = mini.closest('.km-mini');
    // Nur Familien mit ausdruecklich gepflegten Zeichnungen ("zeichnung|<befestigung>"
    // in custom.km_medien) bekommen die Vorschau. Modelle ohne diese Schluessel bleiben
    // unveraendert - sonst wuerde eine Aenderung fuer die Fenstergitter stillschweigend
    // auch die Balkonseiten umbauen.
    var id = (s && s.befestigung) ? MEDIA['zeichnung|' + s.befestigung] : null;
    var url = id ? MEDIA_URL[id] : null;
    if (!url) { if (box && box.classList.contains('km-mini--immer')) box.hidden = true; return; }
    // Die Galerie-URLs sind auf 400 px ausgelegt; in der Zeichnung stecken Details
    // (Schnitt, Bohrbild), die dabei unlesbar werden. Fuer die Vorschau groesser anfordern.
    url = url.replace(/([?&]width=)\d+/, '$1900');
    if (mini.getAttribute('src') !== url) mini.src = url;
    var bez = s.b ? s.b.label : '';
    mini.alt = 'Maßzeichnung Fenstergitter, ' + bez;
    if (box) {
      box.hidden = false;
      box.classList.add('km-mini--immer');
      // Die Zeichnung ist eine feste Werkzeichnung, keine Darstellung der eingegebenen
      // Masse. Die Beschriftung der parametrischen Skizze waere hier eine Falschaussage.
      var txt = box.querySelector('.km-mini__text');
      if (txt) txt.textContent = bez ? 'Maßzeichnung · ' + bez : 'Maßzeichnung';
    }
  }

  function update() {
    var s = state();
    // Sichtbarkeit abhängiger Felder
    // Familien ohne Beschichtung (Edelstahl-Fensterstangen) rendern keinen Farbblock.
    var farbFeld = root.querySelector('[data-show-if="farbe"]');
    if (farbFeld) farbFeld.hidden = !s.m.farbe;
    var wunschFeld = root.querySelector('[data-farbe-wunsch]');
    if (wunschFeld) wunschFeld.hidden = !istWunschfarbe(s);
    renderHandlauf(s);
    setPreiseAnzeigen(s);
    oePreiseAnzeigen(s);
    oeffnungSperre(s);
    s = state();
    var ok = validate(s);
    // Galerie auf das passende Render schalten
    showRender(renderKey(s));
    // Modelle mit Zierfuellung (Raute, Zierblech, V-Muster, waagrechte Staebe) lassen sich
    // mit den beiden Zeichnungsarten nicht ehrlich darstellen. Dort bleibt die Skizze aus,
    // die Galerie zeigt die Werkzeichnung. Steuerung: geometrie.parametrisch === false.
    // Fenstergitter: eigene parametrische Massskizze, unabhaengig von geometrie.parametrisch
    // (das Flag steuert nur die Balkon-Skizze drawSchema).
    if (SK_ID && (R.geometrie || {}).parametrisch !== false) drawSchema(s);
    else if (istGitter()) drawGitter(s);
    else setMiniZeichnung(s);
    // Preis
    var p = price(s);
    els.total.textContent = ok ? fmt(p.total) : '–';
    // Nettobetrag zum tatsaechlich konfigurierten Preis, nicht zu einem Startpreis.
    if (els.netto) {
      if (ok && TAXSATZ !== null && TAXSATZ > 0) {
        var nbsp = String.fromCharCode(160);
        els.netto.textContent = fmt(p.total / (1 + TAXSATZ / 100)) + nbsp + 'netto zzgl.' + nbsp + TAXSATZ + nbsp + '%' + nbsp + 'MwSt.';
        els.netto.hidden = false;
      } else {
        els.netto.hidden = true;
      }
    }
    // Positionsliste: macht sichtbar, was alles ohne Aufpreis dabei ist. Material, Mass,
    // Befestigung und Handlauf stecken im Balkonpreis; nur das Befestigungsmaterial kommt
    // als eigener Betrag dazu.
    if (els.liste) {
      var zeilen = [];
      function zeile(bez, betrag, klasse) {
        zeilen.push('<li class="km-pos' + (klasse ? ' ' + klasse : '') + '">' +
          '<span class="km-pos__bez">' + esc(bez) + '</span>' +
          '<span class="km-pos__wert">' + esc(betrag) + '</span></li>');
      }
      if (ok) {
        // Bezeichnung je Familie: die Liste sagte bei den Fenstergittern "Balkon" (Martin 09.10.2026).
        var posName = 'Balkon';
        if (/Fenstergitter/.test(R.familie_key || '')) posName = /Security Bar/i.test(R.modell || '') ? R.modell : 'Fenstergitter ' + R.modell;
        // Oeffnungsfunktion als eigene Zeile, aus dem Stueckpreis herausgerechnet: gleicher Rabatt,
        // gleiche Rundung wie in price(), die Summe der Zeilen bleibt der Gesamtpreis.
        var oeZeile = 0, oeText = '';
        if (s.oe && R.oeffnung && s.oe.id !== 'ohne' && oePreis(s) > 0) {
          oeZeile = Math.round(Math.round(oePreis(s) * (1 - p.rabatt / 100) * 100) / 100 * TAXF * 100) / 100 * s.menge;
          oeZeile = Math.round(oeZeile * 100) / 100;
          var nS = schlossZahl(s);
          oeText = (R.oeffnung.label || 'Zum Öffnen mit Schloss') + (nS !== null ? ' (' + (nS === 1 ? '1 Schloss' : nS + ' Schlösser') + ')' : '');
        }
        zeile(posName + ' ' + s.m.label + ', ' + (R.hoehe.fest ? s.breite + ' mm' : s.breite + ' × ' + s.hoehe + ' mm') +
          (s.menge > 1 ? ' · ' + s.menge + ' Stück' : ''), fmt(Math.round((p.balkone - oeZeile) * 100) / 100));
        if (oeText) zeile(oeText, fmt(oeZeile));
        if (p.rabatt) {
          var ersparnis = Math.round((p.unit - p.rabattiert) * s.menge * 100) / 100;
          zeile('Mengenrabatt ' + p.rabatt + ' % ist enthalten', '− ' + fmt(ersparnis), 'km-pos--rabatt');
        }
        zeile('Befestigung: ' + s.b.label, 'inkl.');
        var farbFeld = root.querySelector('[data-show-if="farbe"]');
        if (farbFeld && !farbFeld.hidden && s.farbe) zeile('Farbe: ' + farbText(s), 'inkl.');
        if (s.hl) {
          zeile('Handlauf: ' + s.hl.label, Number(s.hl.aufpreis || 0) > 0
            ? '+ ' + fmt(Number(s.hl.aufpreis)) + ' je Stück' : 'inkl.');
        }
        zeile('Befestigungsmaterial: ' + s.s.label, p.sets ? fmt(p.sets) : 'ohne');
      } else {
        zeile((/Fenstergitter/.test(R.familie_key || '') ? 'Fenstergitter' : 'Balkon') + ' (Maße prüfen)', '–');
      }
      els.liste.innerHTML = zeilen.join('');
    }
    els.flag.hidden = !p.vorlaeufig;
    els.add.disabled = !ok;
    // Angebots-Link mit Konfiguration
    els.quote.href = CTX.productUrl + '?view=anfrage&konf=' + encode(s);
    wechselAktualisieren(s);
    // Deep-Link ohne Reload - gedrosselt, siehe deepLink()
    deepLink(s);
    // Knopf sichtbar sperren, solange eine Pflichtauswahl offen ist.
    if (els.add) {
      els.add.classList.toggle('km-btn--gesperrt', !ok);
      els.add.setAttribute('aria-disabled', ok ? 'false' : 'true');
    }
    // Den Grund gleich hinschreiben statt erst beim Klick: einen Knopf mit
    // aria-disabled faengt das Theme ab, die Meldung aus dem Klick-Handler erreicht
    // den Kunden dann nie. Er soll auch nicht raten muessen, warum nichts passiert.
    if (els.msg) {
      if (s.fehlt && s.fehlt.length) {
        els.msg.textContent = 'Bitte treffen Sie noch eine Auswahl: '
          + s.fehlt.map(function (x) { return x.label; }).join(', ') + '.';
        els.msg.className = 'km-msg is-err';
        els.msg.setAttribute('data-km-auswahl', '1');
      } else if (els.msg.getAttribute('data-km-auswahl')) {
        els.msg.textContent = '';
        els.msg.className = 'km-msg';
        els.msg.removeAttribute('data-km-auswahl');
      }
    }
    return { s: s, p: p, ok: ok };
  }

  // Deep-Link lesen
  (function restore() {
    var m = location.hash.match(/konf=([A-Za-z0-9+\/]+)/) || location.search.match(/konf=([A-Za-z0-9+\/]+)/);
    if (!m) return;
    var c = decode(m[1]); if (!c) return;
    // Ein Wert aus dem Deep-Link, den es hier nicht gibt (aelterer Link, geaendertes
    // Regelwerk, Materialwechsel auf ein Schwesterprodukt), darf die Vorauswahl nicht
    // loeschen: sonst ist gar kein Radio gesetzt und die Konfiguration geht ohne
    // Befestigungsart in den Warenkorb. Dann lieber die Vorauswahl stehen lassen.
    var set = function (name, v) {
      var el = form.elements[name]; if (!el || v == null) return;
      if (el.length && el[0] && el[0].type === 'radio') {
        var treffer = false;
        for (var i = 0; i < el.length; i++) if (el[i].value === String(v)) treffer = true;
        if (!treffer) return;
        for (var j = 0; j < el.length; j++) el[j].checked = (el[j].value === String(v));
      } else el.value = v;
    };
    set('material', c.m); set('farbe', c.f); set('farbe_wunsch', c.fw); set('breite', c.b); set('hoehe', c.h); set('befestigung', c.bf); set('menge', c.q); set('set', c.st); set('bemerkung', c.bm);
    if (c.hl) { renderHandlauf(state()); set('handlauf', c.hl); }
    if (c.oe) set('oeffnung', c.oe);
  })();

  // Events
  form.addEventListener('input', function () { nutzerAendert = true; update(); });
  form.addEventListener('change', function () { nutzerAendert = true; update(); });
  root.querySelectorAll('.km-f__step').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = form.elements[btn.dataset.for]; var step = Number(btn.dataset.step);
      input.value = clamp(Number(input.value) + step, Number(input.min), Number(input.max));
      if (btn.dataset.for === 'breite' || btn.dataset.for === 'hoehe') selectSkizze();
      update();
    });
  });
  ['breite', 'hoehe', 'menge'].forEach(function (n) {
    form.elements[n].addEventListener('blur', function () { this.value = clamp(this.value, Number(this.min), Number(this.max)); update(); });
  });
  // Klick ins Maßfeld: direkt das Skizzen-Bild in der Galerie zeigen
  ['breite', 'hoehe'].forEach(function (n) {
    form.elements[n].addEventListener('focus', selectSkizze);
  });
  // Teilen-Knopf ist auf der Produktseite entfernt (Platz). Der Deep-Link #konf=
  // funktioniert unveraendert weiter - der Block bleibt fuer Vorlagen, die den Knopf
  // noch fuehren, deshalb defensiv geprueft.
  if (els.share) {
    els.share.addEventListener('click', function () {
      var url = location.origin + location.pathname + '#konf=' + encode(state());
      (navigator.clipboard ? navigator.clipboard.writeText(url) : Promise.reject()).then(function () { msg('Link kopiert.', true); }, function () { prompt('Link zu dieser Konfiguration:', url); });
    });
  }
  function msg(t, ok) { els.msg.textContent = t; els.msg.className = 'km-msg ' + (ok ? 'is-ok' : 'is-err'); }

  els.add.addEventListener('click', function () {
    var r = update();
    if (!r.ok) {
      // Sagen, was fehlt, und dorthin springen - eine Meldung "bitte pruefen" allein
      // laesst den Kunden raten, welcher Schritt gemeint ist.
      var f = r.s && r.s.fehlt;
      if (f && f.length) {
        msg('Bitte treffen Sie noch eine Auswahl: ' + f.map(function (x) { return x.label; }).join(', ') + '.', false);
        var ziel = root.querySelector('[data-step="' + f[0].schritt + '"]');
        if (ziel) {
          var t = ziel.querySelector('.km-step__toggle');
          if (t && t.getAttribute('aria-expanded') === 'false') t.click();
          ziel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      } else {
        msg('Bitte prüfen Sie die Maße.', false);
      }
      return;
    }
    // Befestigungsset läuft als Property am Balkon mit (keine eigene Position);
    // den Set-Preis rechnet die Cart-Transform-Function in den Stückpreis ein.
    var items = [{ id: CTX.variantId, quantity: r.s.menge, properties: properties(r.s, r.p) }];
    els.add.setAttribute('aria-busy', 'true'); msg('', true);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw new Error(j.description || j.message || 'Fehler'); return j; }); })
      .then(function () { msg('Konfiguration im Warenkorb.', true); window.location.href = '/cart'; })
      .catch(function (e) { msg('Der Artikel konnte nicht in den Warenkorb gelegt werden: ' + e.message, false); })
      .then(function () { els.add.removeAttribute('aria-busy'); });
  });

  update();
  galerieBereit = true;
}
document.querySelectorAll('.km-konfform[data-section-id], .km-konf[data-section-id]').forEach(kmKonfiguratorInit);